import React, { useEffect, useRef, useState } from 'react';
import TrailerModal from './TrailerModal';
import './NowPlaying.css';
import { Link } from 'react-router-dom';
import { fetchMovies, mapMovieForCard } from '../api/starviewApi';
import { useCountry } from '../context/CountryContext';

const NowPlaying = () => {
  const { country } = useCountry();
  const [movies, setMovies] = useState([]);
  const [trailer, setTrailer] = React.useState(null);
  const trackRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    fetchMovies({ size: 20, country })
      .then((rawMovies) => {
        if (cancelled) return;
        setMovies(rawMovies.map(mapMovieForCard));
      })
      .catch((err) => console.error('Failed to load now-playing movies:', err));
    return () => {
      cancelled = true;
    };
  }, [country]);

  const scrollByAmount = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const cardWidth = track.firstElementChild?.getBoundingClientRect().width || 300;
    track.scrollBy({ left: direction * (cardWidth + 40) * 2, behavior: 'smooth' });
  };

  if (movies.length === 0) {
    return <div className="nowplaying-carousel-bg" />;
  }

  return (
    <div className="nowplaying-carousel-bg">
      <button className="nowplaying-arrow-overlay left" onClick={() => scrollByAmount(-1)} aria-label="Scroll left">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L8 12L15 19" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <div className="nowplaying-carousel" ref={trackRef}>
        {movies.map((movie) => (
          <div key={movie.id} className="nowplaying-movie-card-large">
            <img src={movie.image_url} alt={movie.title} className="nowplaying-movie-image" />
            <div className="nowplaying-movie-details">
              <h3 className="nowplaying-movie-title">{movie.title}</h3>
              {movie.audience_stars != null && (
                <div className="nowplaying-star-rating" aria-label={`Audience score ${movie.audience_score}`}>
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s}>{movie.audience_stars >= s ? '★' : movie.audience_stars >= s - 0.5 ? '⯨' : '☆'}</span>
                  ))}
                  <span className="nowplaying-audience-score">{movie.audience_score}</span>
                </div>
              )}
              <p className="nowplaying-movie-runtime-rating">{movie.runtime} • {movie.rating}</p>
              <div className="nowplaying-movie-actions">
                {movie.trailer_url && (
                  <button type="button" onClick={() => setTrailer({ title: movie.title, src: movie.trailer_url })} className="nowplaying-btn nowplaying-trailer-btn">▶ Watch Trailer</button>
                )}
                <Link to={`/Showtimes?movieId=${movie.id}`} className="nowplaying-btn nowplaying-tickets-btn">Get Tickets</Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="nowplaying-arrow-overlay right" onClick={() => scrollByAmount(1)} aria-label="Scroll right">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {trailer && <TrailerModal title={trailer.title} src={trailer.src} onClose={() => setTrailer(null)} />}
    </div>
  );
};

export default NowPlaying;
